export const IS_CLEARING_SECURITY = 'CLEARING_SECURITY';
export const IS_FINISHED_CLEARING_SECURITY = 'FINISHED_CLEARING_SECURITY';

export const SET_SECURITY = 'SET_SECURITY';
export const SAVE_SECURITY_KEY = 'SAVE_SECURITY_KEY';
export const ENABLE_E2E_ENCRYPTION = 'ENABLE_E2E_ENCRYPTION';
export const ON_SECURITY_API_REQUEST = 'ON_SECURITY_API_REQUEST';
export const START_DECRYPTING = 'START_DECRYPTING';
